import InputGroupForm from '../InputGroupForm.vue'
import SelectGroupForm from '../SelectGroupForm.vue'
import http from '@/http-common'
import globalLoadSpr from "../../utils/globalLoadSpr";

export default {
  components: {InputGroupForm, SelectGroupForm},
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      editItem: {},
      validValue: {
        org: true,
        ekptype: true,
        eventkind: true, // вид ЕКП
        nameEvent: true, // наименование мероприятия
        federation: true, // федерация
        sportkind: true, // раздел ЕКП
        location: true, // место проведения
        jobkind: true, // вид работ
        ageKind: true, // возрастная категория
        summaEkp: true, // сумма
        countPeople: true, // кол-во участников
        summaAll: true,
        form: true
      },
      ekpTypeList: [],
      orgList: [],
      kindList: [],
      ageKindList: [],
      jobKindList: [],
      fedList: [],
      locList: [],
      eventKindList: [],
      eventstateList: [],
      modalPlaceOpened: false,
      modalFilesOpened: false,
      captionBtnSave: 'Сохранить',
      canEdit: false,
      modalLoadOpened: false,
      smetaEkp: {
        id: 0,
        managerFIO: '',
        respFIO: '',
        details: []
      },
      sett: {percent: 1},
      heldValue: null,
    }
  },
  created() {
    // this.ekp_id = this.$route.params.id
    this.loadSpr();
    this.loadItem();
  },
  methods: {
    async loadSpr() {
      this.orgList = await globalLoadSpr.loadOrgs()
      this.ekpTypeList = await globalLoadSpr.loadEkpTypes()
      this.ageKindList = await globalLoadSpr.loadAgeKind()
      this.kindList = await globalLoadSpr.loadKind()
      this.jobKindList = await globalLoadSpr.loadJobKind()
      this.eventKindList = await globalLoadSpr.loadEventKind();
      this.fedList = await globalLoadSpr.loadFederations();
      this.eventstateList = await globalLoadSpr.loadEventState()
    },
    loadItem() {
      let vm = this
      vm.modalLoadOpened = true
      http.get('/ekp/' + vm.id)
      .then((response) => {
        vm.editItem = response.data;
        vm.editItem.formulaStr = '=RC[-3]-RC[-2]+RC[-1]';
      })
      .catch((error) => console.log(error.response.data))
      .finally(() => {
        vm.modalLoadOpened = false
        this.$emit('input', this.editItem)
      })
    },
    checkDat1() {
      var datStr = this.editItem.dateBegin;
      if (this.editItem.dateBegin) {
        var dat = new Date(datStr);
        var year = dat.getFullYear();
        this.loadLimit(year, this.editItem.organizationId, this.editItem.ekpTypeId);
        this.loadAllSumm(year, this.editItem.organizationId, this.editItem.ekpTypeId);
      }
      if (this.editItem.dateBegin > this.editItem.dateEnd && this.editItem.dateEnd) {
        this.editItem.dateEnd = this.editItem.dateBegin
      }
    },
    getInfoEkpCreate() {
      var str = '';
      if (this.editItem.cdate || this.editItem.loginC) {
        str = 'создан ';
        if (this.editItem.cdate) {
          str += this.editItem.cdate;
        }
        if (this.editItem.loginC) {
          str += ' ' + this.editItem.loginC;
        }
      }
      return str;
    },
    showFiles() {
      this.showOper = false;
      this.modalFilesOpened = !this.modalFilesOpened
    },
    showPlaceDialog() {
      this.modalPlaceOpened = !this.modalPlaceOpened;
    },
    getLimitInfo() {
      var str = '';
      if (this.allSummEkp) {
        str = "Общая сумма за год = " + this.allSummEkp.toFixed(2) + '; ';
      }
      if (this.limitYear) {
        str += "Лимит на год = " + this.limitYear.toFixed(2) + '; ';
      }
      if (this.limitYear && this.allSummEkp) {
        str += "Остаток на год = " + (this.limitYear - this.allSummEkp).toFixed(2) + ';';
      }
      return str;
    },
    saveEkp() {
      this.checkForm();
      if (this.validValue.form) {
        var addFlag = false;
        if (!this.editItem.id || this.editItem.id === 0) {
          addFlag = true;
        }
        var data = this.editItem;
        var vm = this;
        http.post('/ekp', vm.editItem)
        .then((response) => {
          vm.modalEditOpened = !vm.modalEditOpened;
          var dataR = response.data;
          if (dataR.id > 0) {
            const index = vm.items.map(e => e.id).indexOf(data.id);
            if (index >= 0) {
              for (var key in dataR) {
                vm.items[index][key] = dataR[key];
              }
            }
            if (addFlag) {
              this.items.push(dataR)
            }
            //this.selectItem(this.item);
          } else {
            alert("Ошибка сохранения!!!")
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            alert("Нет прав!")
          } else {
            alert(error.response.message)
          }
        })
        .finally(() => {
          this.$emit('input', this.editItem)
        })
      }
    }
  }
}
